module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    class: _vm.className
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7e7ef58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/columns/Columns.vue
// module id = 136
// module chunks = 0